module.exports = __webpack_public_path__ + "img/whatsapp-phone-half.9d95bd3d.png";